// Support component names relative to this directory:
import Rails from "@rails/ujs";
Rails.start();


import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import 'bootstrap';
